import { render, staticRenderFns } from "./SettingsMenu.vue?vue&type=template&id=aae70316&scoped=true"
import script from "./SettingsMenu.vue?vue&type=script&lang=js"
export * from "./SettingsMenu.vue?vue&type=script&lang=js"
import style0 from "./SettingsMenu.vue?vue&type=style&index=0&id=aae70316&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae70316",
  null
  
)

export default component.exports